import { IDebtorSearchResultModel } from "us.common/reducers/MainSearch/Interfaces";

export const DebtorSearchModel: IDebtorSearchResultModel = {
  data: [],
  isError: false,
  isLoading: false,
};
